import { createAction } from "@ngrx/store";

export const startLoader = createAction("[Loading] Start Loading");

export const stopLoader = createAction("[Loading] Stop Loading");
